import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    myBadgeInfo: 0,// tabbar 徽标信息条数
    JoinShowHidden: false, // 控制入围消息的小红点的显示与隐藏
    VictoryShowHidden: false  // 控制获奖消息的小红点的显示与隐藏
  },
  mutations: {
    alterJoinShowHidden(state) {  // 点进去消息后 让入围的小红点消失
      state.JoinShowHidden = false  
    },
    alterVictoryShowHidden(state) { // 控制获奖消息的小红点消失
      state.VictoryShowHidden = false
    }
  },
  actions: {},
  modules: {}
})
